var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_86419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.459 7.89844H19.5156V12.5968H20.459V7.89844Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5153 12.5977H18.5781V14.4782H19.5153V12.5977Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5153 6.01953H18.5781V7.90009H19.5153V6.01953Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5856 14.4766H17.6484V16.351H18.5856V14.4766Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5856 4.14453H17.6484V6.01893H18.5856V4.14453Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6465 16.3516H16.7031V17.2949H17.6465V16.3516Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6465 3.19922H16.7031V4.14258H17.6465V3.19922Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7009 17.2969H14.8203V18.2341H16.7009V17.2969Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7009 2.26172H14.8203V3.19892H16.7009V2.26172Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1872 11.6587H10.1306V12.5959H11.0678V11.6587H12.005V10.7153H15.7661V9.77811H12.005V8.83474H11.0678V3.19922H10.1306V8.83474H9.1872V9.77811H8.25V10.7153H9.1872V11.6587Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8197 18.2344H12.9453V19.1777H14.8197V18.2344Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8197 1.32031H12.9453V2.26368H14.8197V1.32031Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9483 19.1758H8.25V20.113H12.9483V19.1758Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9483 0.382812H8.25V1.32001H12.9483V0.382812Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25556 18.2344H6.375V19.1777H8.25556V18.2344Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25556 1.32031H6.375V2.26368H8.25556V1.32031Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37275 17.2969H4.49219V18.2341H6.37275V17.2969Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37275 2.26172H4.49219V3.19892H6.37275V2.26172Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49189 16.3516H3.55469V17.2949H4.49189V16.3516Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49189 3.19922H3.55469V4.14258H4.49189V3.19922Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55439 14.4766H2.61719V16.351H3.55439V14.4766Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55439 4.14453H2.61719V6.01893H3.55439V4.14453Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61524 12.5977H1.67188V14.4782H2.61524V12.5977Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61524 6.01953H1.67188V7.90009H2.61524V6.01953Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67157 7.89844H0.734375V12.5968H1.67157V7.89844Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_86419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7305,
    height: 19.7305,
    fill: "white",
    transform: "translate(0.734375 0.382812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.86184658b392f2475939b4bcfb220601.svg";
export { ForwardRef as ReactComponent };